<div class="wrapper">
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/participant">Participant</a></li>
              <li class="breadcrumb-item active">Edit Participant</li>
            </ol>
          </div>
          <h4 class="page-title">Edit Participant</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">
        <div class="card-box">
          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="row" *ngIf="raiseWarning">
              <div class="col-md-12 form-horizontal px-3">
                <ngb-alert [dismissible]="false">
                  <strong>Warning!</strong> {{warning}}
                </ngb-alert>
              </div>
            </div>

            <div class="row" *ngIf="raiseDanger">

              <div class="col-md-12 form-horizontal px-3">
                <ngb-alert type="danger" [dismissible]="false">
                  <strong>Error!</strong> {{danger}}
                </ngb-alert>
              </div>
            </div>

            <ul ngbNav #nav="ngbNav" class="nav nav-tabs">
              <!--[(activeId)]="active"-->
              <li [ngbNavItem]="1">
                <a ngbNavLink>Participant Configuration</a>
                <ng-template ngbNavContent>
                  <div class="form-group row">
                    <label for="name" class="col-3 col-form-label">Name </label>
                    <div class="col-9">
                      <input [(ngModel)]="participant.name" [ngModelOptions]="{standalone: true}"
                             class="form-control" id="name" placeholder="Name">
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="isAggregator" class="col-3 col-form-label">Is Aggregator</label>
                    <div class="col-9">
                      <input [(ngModel)]="participant.isAggregator" [ngModelOptions]="{standalone: true}" type="checkbox"
                             id="isAggregator" placeholder="Postilion Participant ID" (change)="IsAggregator($event)">
                    </div>
                  </div>


                  <div *ngIf="participant.isAggregator">
                    <div class="form-group row">
                      <label for="aggregatorMerchant" class="col-3 col-form-label">Aggregator Merchant</label>
                      <div class="col-9">
                        <input [(ngModel)]="participant.aggregatorMerchant" [ngModelOptions]="{standalone: true}" maxlength="15"
                               class="form-control" id="aggregatorMerchant" placeholder="Aggregator Merchant"
                               (change)="validateMerchantNumber()" [style]="disableFields">
                      </div>
                    </div>

                    <div class="form-group row">
                      <label for="aggregatorSinkNode" class="col-3 col-form-label">Aggregator Sink Node</label>
                      <div class="col-9">
                        <ng-select2 id="aggregatorSinkNode" [(ngModel)]="participant.aggregatorSinkNode"
                                    [ngModelOptions]="{standalone: true}" [data]="sinkNodes" [options]="select2options"
                                    placeholder="Aggregator Sink Node" [style]="disableFields"></ng-select2>
                        <!--<input [(ngModel)]="participant.aggregatorSinkNode" [ngModelOptions]="{standalone: true}" class="form-control" id="aggregatorSinkNode" placeholder="Aggregator Sink Node">-->
                      </div>
                    </div>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="2">
                <a ngbNavLink>Merchant Management Settings</a>
                <ng-template ngbNavContent>
                  <div class="form-group row">
                    <label for="hasBankingDetails" class="col-3 col-form-label">Hide Banking Details Tab</label>
                    <div class="col-9">
                      <input [(ngModel)]="participant.hasBankingDetails" [ngModelOptions]="{standalone: true}" type="checkbox"
                             id="hasBankingDetails" placeholder="Show Banking Details">
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="hasContactDetails" class="col-3 col-form-label">Hide Contact Details Tab</label>
                    <div class="col-9">
                      <input [(ngModel)]="participant.hasContactDetails" [ngModelOptions]="{standalone: true}" type="checkbox"
                             id="hasContactDetails" placeholder="Show Contact Details">
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="hasCommissionDetails" class="col-3 col-form-label">Hide Commission Details Tab</label>
                    <div class="col-9">
                      <input [(ngModel)]="participant.hasCommissionDetails" [ngModelOptions]="{standalone: true}" type="checkbox"
                             id="hasCommissionDetails" placeholder="Show Commission Details">
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="hasValueAddedService" class="col-3 col-form-label">Hide Value Added Services Tab</label>
                    <div class="col-9">
                      <input [(ngModel)]="participant.hasValueAddedService" [ngModelOptions]="{standalone: true}" type="checkbox"
                             id="hasValueAddedService" placeholder="Show Value Added Service">
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="hasValueAddedService" class="col-3 col-form-label">Hide PFI information</label>
                    <div class="col-1">
                      <input [(ngModel)]="participant.removePFIDetails" [ngModelOptions]="{standalone: true}" type="checkbox"
                             id="removePFIDetails" placeholder="Payment Facilitator ID">

                    </div>
                    <div class="col-8">
                      <i style="font-size:10px; color: darkseagreen"> Please note that this setting only apply to merchants that routes to any bank other than ABSA</i>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="hasValueAddedService" class="col-3 col-form-label">Enable ABSA O1 Token</label>
                    <div class="col-1">
                      <input [(ngModel)]="participant.absaO1Token" [ngModelOptions]="{standalone: true}" type="checkbox"
                             id="absaO1Token" placeholder="ABSA O1 Token">
                    </div>
                    <div class="col-8">
                      <i style="font-size:10px; color: darkseagreen"> ABSA O1 Token apply to only merchants routing to ABSA - [only Customer phone nr and merchant street address are part of the Token] </i>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="ActivateSerialNumber" class="col-3 col-form-label">Activate serial number on terminal creation screen</label>
                    <div class="col-9">
                      <input [(ngModel)]="activateSerialNumber" [ngModelOptions]="{standalone: true}" type="checkbox"
                             id="activateSerialNumber" placeholder="Activate serial number on terminal creation screen" />
                    </div>
                  </div>

                </ng-template>
              </li>
              <li [ngbNavItem]="3" *ngIf="adminUser">
                <a ngbNavLink>To be deleted</a>
                <ng-template ngbNavContent>

                  <div class="form-group row">
                    <label for="name" class="col-3 col-form-label">Total count to process: </label>
                    <div class="col-9">
                      <input [(ngModel)]="totalCount" [ngModelOptions]="{standalone: true}"
                             class="form-control" id="totalCount" placeholder="Name">
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-12">

                      <input type="file" (change)="onFileChange($event)" accept=".csv">
                      <div *ngIf="csvData">
                        <h2>CSV Data:</h2>
                        <table>
                          <tr *ngFor="let row of csvData">
                            <td *ngFor="let cell of row">{{ cell }}</td>
                          </tr>
                        </table>
                      </div>

                      <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="runExport()">
                        Export mapped sd tags
                      </button>
                    </div>
                  </div>
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="nav" class="tab-pane">
            </div>
            <div class="form-group mb-0 justify-content-end row">
              <div class="col-9">
                <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="save()">
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
